<!-- TopBar -->
<app-header></app-header>

<!-- Content -->
<div id="wrapper-main">
  <div *ngIf="mediaBreakpoint !== SCREEN_SIZE.XS && mediaBreakpoint !== SCREEN_SIZE.SM">
    <div>
      <app-enterprise-sidebar></app-enterprise-sidebar>
    </div>
  </div>
  <div class="d-flex flex-column" id="content-wrapper">
    <!-- Main Content -->
    <div id="content">
      <!-- Begin Page Content -->
      <!-- <div class="container-fluid"
        [ngClass]="{'px-0': router.url.indexOf('add-document') >= 0 || router.url == '/home-enterprise/main' || router.url.indexOf('view-document') >= 0 || router.url.indexOf('update-document') >= 0}"> -->
      <div class="container-fluid">
        <!-- Content Row -->
        <div>

          <!-- breadcrumb -->
          <div class="d-sm-flex align-items-center justify-content-between" id="breadcrumb">
            <app-breadcrumbs></app-breadcrumbs>
          </div>
          <router-outlet></router-outlet>
        </div>
        <!-- Content Row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- End of Main Content -->

    <!-- Footer -->
    <app-footer
      [hidden]="router.url.indexOf('add-document') >= 0
        || router.url.indexOf('view-document') >= 0
        || router.url.indexOf('update-document') >= 0
        || router.url.indexOf('sign-document') >= 0
        || router.url.indexOf('digital-contract') >= 0
        || router.url.indexOf('sign-digital-flow') >= 0
        || router.url.indexOf('contract-digitzation-moha') >= 0
        
      ">
    </app-footer>

    <!-- End of Footer -->
  </div>
  <!-- End of Content Wrapper -->
</div>
